"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const material_1 = require("@mui/material");
const material_ui_confirm_1 = require("material-ui-confirm");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ isProceeding, tempData, setTempModalOpen, setTempData, roomDataId, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const dispatch = (0, react_redux_1.useDispatch)();
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const tempLoadingConfirm = (roomId) => {
        const tempLoading = () => {
            dispatch((0, roomCreateStore_1.getRoomData)(`${roomId}`));
            dispatch((0, roomCreateStore_1.getProductsData)(roomId));
            setTempModalOpen(false);
        };
        confirm({
            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('작성중인 내용 대신'), (0, jsx_runtime_1.jsx)("br", {}), t('선택한 임시저장을 불러오시겠어요?')] })),
            confirmationText: t('불러오기'),
        })
            .then(tempLoading)
            .catch(() => { });
    };
    const deleteTempData = (roomId) => __awaiter(this, void 0, void 0, function* () {
        const deleteTemp = () => {
            (0, api_1.deleteData)(`/api/v1/store/room/${roomId}`)
                .then(() => {
                (0, api_1.getData)(`/api/v1/room/temp`)
                    .then((res) => __awaiter(this, void 0, void 0, function* () {
                    if (res.status === 200) {
                        setTempData(res.data.result);
                    }
                }))
                    .catch(() => {
                    confirm({
                        description: (0, errors_1.commonErrorMsg)(),
                        cancellationButtonProps: { style: { display: 'none' } },
                    });
                });
                if (roomId == roomDataId) {
                    (0, functions_1.goToCreateRoom)();
                }
            })
                .catch(() => {
                confirm({
                    description: (0, errors_1.commonErrorMsg)(),
                    cancellationButtonProps: { style: { display: 'none' } },
                });
            });
        };
        confirm({
            description: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('선택한 임시저장을 삭제하시겠어요?') }),
            confirmationText: t('삭제'),
        })
            .then(deleteTemp)
            .catch(() => { });
    });
    return ((0, jsx_runtime_1.jsxs)(SaveContainer, Object.assign({ isProceeding: isProceeding }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { width: maxWidth768 ? '69%' : '59%' } }, { children: [(0, jsx_runtime_1.jsx)("h4", Object.assign({ className: "text_overflow", css: { WebkitLineClamp: 1 } }, { children: tempData.title })), (0, jsx_runtime_1.jsx)("h5", { children: tempData.mod_dt.slice(0, 16).replace(/-/g, '.').replace('T', ' ') })] })), isProceeding ? ((0, jsx_runtime_1.jsx)(TempLoadingBtn, Object.assign({ css: {
                    width: 111,
                    backgroundColor: '#f8f8f8 !important',
                    border: 0,
                    color: 'rgba(0, 0, 0, 0.2)',
                } }, { children: t('지금 작성중인 폼') }))) : ((0, jsx_runtime_1.jsx)(TempLoadingBtn, Object.assign({ css: {
                    width: 77,
                    backgroundColor: '#ffffff !important',
                    border: '1px solid #000000',
                    color: '#000000',
                    cursor: 'pointer',
                }, onClick: () => tempLoadingConfirm(tempData.id) }, { children: t('불러오기') }))), (0, jsx_runtime_1.jsx)(material_1.IconButton, Object.assign({ className: "delete_question", onClick: () => {
                    deleteTempData(tempData.id);
                } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.XCircleGraySvg, { css: { width: '16px', height: '16px', borderRadius: '50%', backdropFilter: 'blur(10px)' } }) }))] })));
}
exports.default = default_1;
// eslint-disable-next-line prettier/prettier
const SaveContainer = styled_1.default.div `
  position: relative;
  display: flex;
  height: 72px;
  padding: 14px 16px;
  border: ${props => (props.isProceeding ? '1px solid #EE7744' : '0.5px solid rgba(0, 0, 0, 0.2)')};
  border-radius: 6px;
  div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
  }
  h4 {
    font-weight: ${props => (props.isProceeding ? '700' : '400')};
    font-size: 16px;
    line-height: 18px;
    color: ${props => (props.isProceeding ? '#EE7744' : '#000000')};
  }
  h5 {
    font-size: 13px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.4);
  }
  .delete_question {
    position: absolute;
    top: -9.5px;
    right: -8.5px;
  }
`;
const TempLoadingBtn = styled_1.default.button `
  position: absolute;
  right: 10px;
  bottom: 10px;
  padding: 8px 10px;
  height: 32px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
`;
